module.exports = __webpack_public_path__ + "assets/media/login-popup.1d02e255.svg";